/* eslint-disable import/no-unresolved */
import { useEffect } from 'react';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import { Container } from '@material-ui/core';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useSettings from 'src/hooks/useSettings';
import { useDispatch, useSelector } from 'src/redux/store';
import useAuth from 'src/hooks/useAuth';
import MyProfile from 'src/components/_dashboard/user-profile/MyProfile';
import { getUserRoleList } from 'src/redux/slices/user_role';

// ----------------------------------------------------------------------

export default function MyProfilePage() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { userRoleList } = useSelector((state) => state.user_role);

  useEffect(() => {
    dispatch(getUserRoleList(true));
  }, [dispatch]);

  return (
    <Page title="My Profile | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <HeaderBreadcrumbs
          heading="My Profile"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'My Profile', href: PATH_DASHBOARD.user.profile },
            { name: `${user.first_name} ${user.last_name}` }
          ]}
        />
        <MyProfile USER_ROLE_LIST={userRoleList} currentUser={user} />
      </Container>
    </Page>
  );
}
